export default __webpack_public_path__ + "resources/icons/d420-3f50.png";